import westvillage1 from '../../../Media/Ruko BSD/West Village/West Village (1).webp'
import westvillage2 from '../../../Media/Ruko BSD/West Village/West Village (2).webp'

const westvillageimages =[
westvillage1,westvillage2
]

export default westvillageimages;
